import { ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import { IconMagnifierComponent } from '../../../features';
import { useTheme } from '../../../hooks';
import { handleToggleSearchForm } from '../search.actions';
import * as S from './searchButtonMobile.styled';
import {
  getOpenSearchEventName,
  getSearchEventData,
} from '../search.analytics';
import { pushDataLayer } from '../../../services';
import { SearchButtonMobileModel } from './searchButtonMobile.model';

export const SearchButtonMobileContainer = ({
  isSticky,
}: SearchButtonMobileModel): ReactElement => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const handleOpen = (): void => {
    dispatch(handleToggleSearchForm(true, null));

    pushDataLayer(getSearchEventData(getOpenSearchEventName(isSticky)));
  };

  return (
    <S.SearchButtonMobile onClick={handleOpen}>
      <IconMagnifierComponent
        width={24}
        height={24}
        fillColor={theme.COLOR.TEXT_DARK_COLOR}
        strokeColor={theme.COLOR.TEXT_DARK_COLOR}
      />
    </S.SearchButtonMobile>
  );
};
